import { VOICE_TRAITS } from "@/data/onboarding";
import { StepShell } from "../OnboardingPrimitives";

export default function StepVoice({ state, update, toggleArrayItem }) {
  return (
    <StepShell
      stepId="voice"
      eyebrow="Step 03 · Your voice"
      title={<>How should the <span className="italic text-aurora">Studio sound?</span></>}
    >
      <div className="space-y-7">
        <div>
          <p className="text-sm text-neutral-600 mb-4">Pick the traits that fit you. Choose 1&ndash;3.</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-3">
            {VOICE_TRAITS.map((t) => {
              const active = state.voice_traits.includes(t.id);
              return (
                <button
                  key={t.id}
                  type="button"
                  data-testid={`onboarding-trait-${t.id}`}
                  onClick={() => toggleArrayItem("voice_traits", t.id)}
                  className={`px-4 py-3 rounded-sm text-sm transition border text-left ${
                    active
                      ? "border-transparent aurora-border bg-[#FAFAFA] text-neutral-900"
                      : "border-neutral-200 hover:border-[#D4AF37]/60 text-neutral-600"
                  }`}
                >
                  {t.label}
                </button>
              );
            })}
          </div>
        </div>
        <div>
          <label htmlFor="ob-sample" className="overline block mb-3">A line you&apos;ve actually written (optional)</label>
          <textarea
            id="ob-sample"
            data-testid="onboarding-voice-sample"
            value={state.voice_sample}
            onChange={(e) => update("voice_sample", e.target.value)}
            placeholder="Paste a sentence from your bio, an email, or a post you're proud of."
            rows={3}
            maxLength={600}
            className="editorial-input resize-none"
          />
          <p className="text-xs text-neutral-500 mt-2">The Studio learns your real voice better from a sample than a label.</p>
        </div>
      </div>
    </StepShell>
  );
}
